import React, { memo } from 'react'
import { Button } from '@mui/material'

const SubmitButton = ({
  label,
  fullWidth = false,
  type = 'submit',
  ...restProps
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      color='inherit'
      size='large'
      type={type}
      variant='contained'
      loadingPosition='end'
      {...restProps}
    >
      {label}
    </Button>
  )
}

export default memo(SubmitButton)
